import type { RestrictivePractice } from '@lmc/validations'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'
import { ReadEntry, ReadItem, ReadWide } from '../../readLayout'
import { practiceValues } from '../../readRules'

type RestrictivePracticeReadBlockProps = {
  /** Its place in the list, from 1, which titles it. */
  number: number
  practice: RestrictivePractice
  testId: string
}

/** One recorded practice, read only: titled by its number, as designed. */
const RestrictivePracticeReadBlock = ({
  number,
  practice,
  testId
}: RestrictivePracticeReadBlockProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)
  const values = practiceValues(t, practice)

  return (
    <ReadEntry
      title={t(incidentReportsConstants.CASE_V2_VIEW_RESTRICTIVE_PRACTICE, {
        number
      })}
      testId={testId}
    >
      <ReadItem
        label={t(incidentReportsConstants.CASE_V2_VIEW_RESTRICTIVE_TYPE)}
        value={values.type}
        testId={`${testId}-type`}
      />
      <ReadItem
        label={t(incidentReportsConstants.CASE_V2_RESTRICTIVE_METHOD)}
        value={values.method}
      />
      <ReadItem
        label={t(incidentReportsConstants.CASE_V2_RESTRICTIVE_DURATION)}
        value={values.duration}
      />
      <ReadItem
        label={t(
          incidentReportsConstants.CASE_V2_RESTRICTIVE_DE_ESCALATION_SUMMARY
        )}
        value={values.deEscalation}
      />
      <ReadWide>
        <ReadItem
          label={t(
            incidentReportsConstants.CASE_V2_RESTRICTIVE_INTERVENTION_TYPE
          )}
          value={values.interventionType}
        />
      </ReadWide>
      <ReadWide>
        <ReadItem
          label={t(incidentReportsConstants.CASE_V2_RESTRICTIVE_REASON)}
          value={practice.reasonForUse}
        />
      </ReadWide>
      <ReadWide>
        <ReadItem
          label={t(incidentReportsConstants.CASE_V2_RESTRICTIVE_OUTCOME)}
          value={values.outcomes}
        />
      </ReadWide>
      <ReadWide>
        <ReadItem
          label={t(incidentReportsConstants.CASE_V2_RESTRICTIVE_NOTES)}
          value={practice.notes}
        />
      </ReadWide>
    </ReadEntry>
  )
}

export default RestrictivePracticeReadBlock
